<script setup lang="ts"></script>

<template>
  <div class="px-3 py-2">
    <slot></slot>
  </div>
</template>
